// @flow
import { type Event, getEventCategoryProducts } from './config';

const retryAction = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Toast',
  label: 'Retry',
});

const undoDelete = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Toast',
  label: 'Undo delete',
});

const closeToast = (): Event => ({
  category: getEventCategoryProducts(),
  action: 'Toast',
  label: 'Close',
});

export default {
  retryAction,
  undoDelete,
  closeToast,
};
